import { useEscriptOnboardingContext } from '@/context/escript/EscriptOnboardingProvider';
import { Button, Stack } from '@montugroup/design-system';
import { styled } from '@mui/material';

const ButtonContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingBottom: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

function EscriptUploadBtn() {
  const { toggleModal } = useEscriptOnboardingContext();

  return (
    <ButtonContainer>
      <Button variant="contained" size="large" onClick={toggleModal}>
        Upload eScript token
      </Button>
    </ButtonContainer>
  );
}

export default EscriptUploadBtn;
